import queryString from 'query-string';
import { get, post } from './apiUtils';

const defaultUrl = '/productActions/';

export default {
  getProductActionList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveProductAction: data => post(defaultUrl, data),
};
